<template>
  <div>
    <p class="description">
      Для оформления займа нам нужно определить ваше местонахождение. Данные о вашем местонахождении никогда не
      будут переданы третьим лицам, и будут использованы только в процессе оформления договора.
    </p>
    <p>Измените это в настройках устройства и повторите попытку</p>
    <ul>
      <li>
        <a href="https://yandex.ru/support/common/browsers-settings/geolocation.html" target="_blank"
           class="linkColor">Изменить настройки</a>
      </li>
      <li>
        <a href="https://support.apple.com/ru-ru/HT207092" target="_blank" class="linkColor">Инструкции для
          владельцев Apple</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "geoErrorDescription"
}
</script>

<style scoped>

</style>